export const generateID = (prefix: string): string => {
  if (prefix === '') {
    throw Error('prefix must be supplied')
  }
  
  const cryptoObj: Crypto = window.crypto || self.crypto
  const array = new Uint8Array(5)
  cryptoObj.getRandomValues(array)

  const randomString = Array.from(array, byte => (byte % 10).toString()).join('')

  return `${prefix}-${randomString}`
}
